var COPY_TENANT_ID_TIMEOUT_IN_MS = 3000;

export { COPY_TENANT_ID_TIMEOUT_IN_MS };
